// Single source of truth for sentiment-tag colours so the feedback list,
// detail modal, and form-results modal can never drift apart again.
//
// We deliberately stick with the green/red/grey convention even though it
// doesn't match the senloop brand palette: status indicators rely on
// muscle memory more than aesthetics, and overriding the convention with
// brand colours forces users to read the label instead of pattern-match
// the colour. We use `emerald` and `stone` (rather than plain `green`
// and `gray`) so the warm-leaning shades sit comfortably against the
// cream background instead of clashing with the fuchsia primary.

export type Sentiment = 'positive' | 'negative' | 'neutral' | string

export function getSentimentClasses(sentiment: Sentiment | null | undefined): string {
  switch (sentiment?.toLowerCase()) {
    case 'positive':
      return 'bg-emerald-100 text-emerald-800 border-emerald-200'
    case 'negative':
      return 'bg-red-100 text-red-800 border-red-200'
    case 'neutral':
      return 'bg-stone-100 text-stone-700 border-stone-200'
    default:
      return 'bg-stone-100 text-stone-700 border-stone-200'
  }
}
